
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseRepositoryInterface, DatabaseUserInterface } from '@/services/Database/interfaces';
import { DataTableHeader } from 'vuetify';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import DeleteDatabaseUserDialog from '@/components/dialogs/databases/DeleteDatabaseUserDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    DeleteDatabaseUserDialog,
  },
  inject: [
    'serverRepository',
    'databaseRepository',
  ],
})
export default class ViewDatabaseUserDialog extends Vue {
  @Prop() private readonly userId!: number;
  private user!: DatabaseUserInterface;

  private serverRepository!: ServerRepositoryInterface;
  private databaseRepository!: DatabaseRepositoryInterface;
  private servers: ServerInterface[] = [];

  private visible: boolean = true;
  private loading: boolean = true;

  private deleteUserDialog: string = '';
  private deleteUserForDialog: DatabaseUserInterface | false = false;

  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'Server', value: 'server' },
    { text: 'Status', value: 'status' },
  ];

  private statuses: string[] = ['CREATING', 'CREATED', 'ERROR', 'ACTIVE', 'DISABLED'];

  public async created(): Promise<void> {
    try {
      this.servers = await this.serverRepository.getAllServers();
      this.user = await this.databaseRepository.getUserById(this.userId);
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private getServerName(serverId: string): string {
    const server = this.servers.find((s) => s._id === serverId);
    if (!server) {
      return '';
    }

    return server.hostname;
  }

  private async editUser(): Promise<void> {
    await this.$router.push({ name: 'database_user_edit', params: { userId: String(this.user.id) } });
  }

  private deleteUser(): void {
    this.deleteUserDialog = 'delete-database-user-dialog';
    this.deleteUserForDialog = this.user;
  }

  private filterUsers(): void {
    this.visible = false;
    this.$emit('user-deleted', this.user);
    this.$emit('close');
  }

  private close(): void {
    this.visible = true;
    this.$emit('close');
  }

  private async deleteLog(id: number): Promise<void> {
    try {
      await this.databaseRepository.deleteUserLog(id);
      this.$successDialog.show('Log deleted successfully');
      this.user.logs = this.user.logs.filter((log) => log.id !== id);
      this.$forceUpdate();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }
}
